import React, { createContext, useState, useContext, useEffect } from 'react';
import i18n from 'i18next';

// Create the language context
const LanguageContext = createContext();

// Language provider component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get the language from localStorage or use browser language or default to English
    return localStorage.getItem('language') || 
           (navigator.language && navigator.language.split('-')[0]) || 
           'en';
  });

  // Change language function
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  // Set the initial language
  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  // Get the available languages from i18n resources
  const getAvailableLanguages = () => {
    return Object.keys(i18n.options.resources || {});
  };

  // Context value
  const value = {
    language,
    changeLanguage,
    availableLanguages: getAvailableLanguages(),
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use the language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;